import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityCallInput = () => {
  const { callId = '' } = useParams();
  const decodedId = callId ? atob(callId) : callId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityCall';

  useEffect(() => {
    if (callId) { setIsEditing(true); fetchDetails(); }
  }, [callId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityCall'] + id + '/', { headers });
      const d = response.data?.data ?? response.data;
      setFormData({
        ...d,
        opportunity: d.opportunity?.id ?? d.opportunity,
        handled_by: d.handled_by?.id ?? d.handled_by,
      });
    } catch (error) { console.error('Error fetching Opportunity Call details:', error); }
  };

  const fields = [
    {
      name: 'opportunity', label: 'Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    {
      name: 'call_type', label: 'Call Type', type: 'select',
      options: [
        { value: 'inbound', label: 'Inbound' },
        { value: 'outbound', label: 'Outbound' },
        { value: 'missed', label: 'Missed' },
      ],
    },
    { name: 'call_date', label: 'Call Date & Time', type: 'datetime-local', dateConstraint: 'future' },
    { name: 'duration', label: 'Duration (mins)', type: 'number' },
    {
      name: 'outcome', label: 'Outcome', type: 'select',
      options: [
        { value: '', label: '— Select Outcome —' },
        { value: 'interested', label: 'Interested' },
        { value: 'not_interested', label: 'Not Interested' },
        { value: 'callback_requested', label: 'Callback Requested' },
        { value: 'no_answer', label: 'No Answer' },
        { value: 'left_message', label: 'Left Message' },
        { value: 'other', label: 'Other' },
      ],
    },
    { name: 'notes', label: 'Notes', type: 'textarea' },
    {
      name: 'handled_by', label: 'Handled By', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Call' : 'Create Opportunity Call'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityCallInput;
